"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._debugPrint_protoSection = exports._debugPrint_layer = exports._loadRegionsInfo = exports._loadLayersInfo = exports.loadSectionPrototypes = exports.gen_httpLoad = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var namespace = 'battlescape-sections-loader';
// Generator to load a text file from a URL
function gen_httpLoad(url) {
    var responsePromise, responseText;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                responsePromise = fetch(url);
                responseText = null;
                responsePromise
                    .then(function (_response) {
                    // console.log('loaded 1', url)
                    _response.text().then(function (text) {
                        // console.log('loaded 2', url)
                        responseText = text;
                    });
                })
                    .catch(function (e) {
                    console.log('error', e);
                    throw e;
                });
                _a.label = 1;
            case 1:
                if (!!responseText) return [3 /*break*/, 3];
                return [4 /*yield*/, null];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3:
                console.log('generator loaded', url);
                return [2 /*return*/, responseText];
        }
    });
}
exports.gen_httpLoad = gen_httpLoad;
function loadSectionPrototypes(str) {
    var startingString = 'version:2:raw:';
    if (!str.startsWith(startingString)) {
        console.warn("invalid file, doesn't start with", startingString);
    }
    // Remove the starting string
    str = str.slice(startingString.length);
    var saveInfo = JSON.parse(str);
    var layer = _loadLayersInfo(saveInfo.layersInfo);
    var protoSections = _loadRegionsInfo(saveInfo.regionsInfo, layer);
    return protoSections;
}
exports.loadSectionPrototypes = loadSectionPrototypes;
function _loadLayersInfo(layersInfo) {
    assert_sidecar_1.assert.notNil(layersInfo, 'layersInfo');
    // let layers: ILayer[] = []
    var layer = {
        tileWidth: 0,
        tileHeight: 0,
        tiles: [],
    };
    var loadLayer = function (layerInfo, iLayer) {
        console.log(namespace, 'layer', iLayer, layerInfo.n);
        var layerNum = -1;
        if (layerInfo.n === 'Background') {
            layerNum = 0;
            return; // skip for now
        }
        else if (layerInfo.n === 'Midground') {
            layerNum = 1;
        }
        else if (layerInfo.n === 'Foreground') {
            layerNum = 2;
        }
        else {
            console.warn('unknown layer', layerInfo.n);
            console.log(namespace, 'skipping layer', layerInfo.n);
            return; // skip for now
        }
        // let idx = 0
        if (layer.tileWidth === 0) {
            layer.tileWidth = layerInfo.w;
            layer.tileHeight = layerInfo.h;
            // Create our layer
            for (var j = 0; j < layer.tileHeight; j++) {
                for (var i = 0; i < layer.tileWidth; i++) {
                    var tile = {
                        ox: i,
                        oy: j,
                        tx: 0,
                        ty: 0,
                        tileIdx: 0,
                        tileIdxUp: 0,
                        color: 0,
                        rotation: 0,
                        horizSpanCount: 0,
                        vertSpanCount: 0,
                    };
                    // idx++
                    layer.tiles.push(tile);
                }
            }
            // layers.push(layer)
        }
        if (layerInfo.tsz) {
            var tsz = layerInfo.tsz;
            var tszParts = tsz.split('|');
            var lastType_1 = -1;
            var lastSubTileIdx = -1;
            var lastColor_1 = -1;
            var lastRotation_1 = -1;
            var idx_1 = 0;
            var addTiles = function (num) {
                // let tileData = voyageTileData2.get(lastType)
                for (var i = 0; i < num; i++) {
                    if (layerNum === 1) {
                        console.log('setting', layer.tiles.length, idx_1);
                        layer.tiles[idx_1].tileIdx = lastType_1;
                        layer.tiles[idx_1].color = lastColor_1;
                        layer.tiles[idx_1].rotation = lastRotation_1;
                    }
                    if (layerNum === 2) {
                        layer.tiles[idx_1].tileIdxUp = lastType_1; // Should other layers have rotation, etc?
                    }
                    idx_1++;
                }
            };
            for (var iTszPart = 0; iTszPart < tszParts.length; iTszPart++) {
                var tszPart = tszParts[iTszPart];
                if (tszPart.startsWith('T')) {
                    lastType_1 = parseInt(tszPart.substring(1));
                }
                if (tszPart.startsWith('S')) {
                    lastSubTileIdx = parseInt(tszPart.substring(1));
                }
                if (tszPart.startsWith('C')) {
                    lastColor_1 = parseInt(tszPart.substring(1));
                }
                if (tszPart.startsWith('R')) {
                    lastRotation_1 = parseInt(tszPart.substring(1));
                    // console.log('tri', 'set rotation', lastRotation)
                }
                if (tszPart.startsWith('1')) {
                    addTiles(1);
                }
                if (tszPart.startsWith('X')) {
                    var num = parseInt(tszPart.substring(1));
                    addTiles(num);
                }
            }
        }
    };
    console.log(namespace, 'loading layers');
    for (var iLayer = 0; iLayer < layersInfo.num; iLayer++) {
        var layerInfo = layersInfo.layers[iLayer];
        loadLayer(layerInfo, iLayer);
    }
    // for (let iTempLayer = 0; iTempLayer < layersInfo.numTemp; iTempLayer++) {
    //   let tempLayerInfo = layersInfo.tempLayers[iTempLayer] as ILayerInfo
    //   loadLayer(tempLayerInfo, iTempLayer)
    // }
    _debugPrint_layer(layer);
    return layer;
}
exports._loadLayersInfo = _loadLayersInfo;
function _loadRegionsInfo(regionsInfo, layer) {
    var protoSections = [];
    // Transfer layers to sections
    for (var iRegion = 0; iRegion < regionsInfo.num; iRegion++) {
        var regionInfo = regionsInfo.regions[iRegion];
        var protoSection = {
            name: regionInfo.n,
            tileWidth: regionInfo.w,
            tileHeight: regionInfo.h,
            tiles: [],
        };
        for (var j = 0; j < protoSection.tileHeight; j++) {
            for (var i = 0; i < protoSection.tileWidth; i++) {
                var tile = {
                    ox: i,
                    oy: j,
                    tx: 0,
                    ty: 0,
                    tileIdx: 0,
                    tileIdxUp: 0,
                    color: 0,
                    rotation: 0,
                    horizSpanCount: 0,
                    vertSpanCount: 0,
                };
                // Copy idx / data from layer
                //let layer = layers[0]
                var idx = (j + regionInfo.y) * layer.tileWidth + (i + regionInfo.x);
                var layerTile = layer.tiles[idx];
                tile.tileIdx = layerTile.tileIdx;
                tile.tileIdxUp = layerTile.tileIdxUp;
                tile.color = layerTile.color;
                tile.rotation = layerTile.rotation;
                // console.log('tri', 'copy rot', tile.rotation)
                protoSection.tiles.push(tile);
            }
        }
        protoSections.push(protoSection);
        _debugPrint_protoSection(protoSection);
    }
    return protoSections;
}
exports._loadRegionsInfo = _loadRegionsInfo;
function _debugPrint_layer(layer) {
    var str = '';
    console.log('debug print layer', layer.tileWidth, layer.tileHeight);
    for (var j = 0; j < layer.tileHeight; j++) {
        for (var i = 0; i < layer.tileWidth; i++) {
            var tile = layer.tiles[j * layer.tileWidth + i];
            str += tile.tileIdx + ' ';
        }
        str += '\n';
    }
    console.log(str);
}
exports._debugPrint_layer = _debugPrint_layer;
function _debugPrint_protoSection(protoSection) {
    var str = '';
    console.log('debug print proto section', protoSection.name, protoSection.tileWidth, protoSection.tileHeight);
    for (var j = 0; j < protoSection.tileHeight; j++) {
        for (var i = 0; i < protoSection.tileWidth; i++) {
            str += protoSection.tiles[j * protoSection.tileWidth + i].tileIdx + ' ';
        }
        str += '\n';
    }
    console.log(str);
}
exports._debugPrint_protoSection = _debugPrint_protoSection;
